/**
 * Unwrap a value that may have been wrapped in an array by DRF's
 * ValidationError serializer.  DRF returns `{"field": ["message"]}`
 * but the frontend usually just wants the bare string.
 *
 * @param {*} val - The value to unwrap.
 * @returns {*} The first element if `val` is an array, otherwise `val` itself.
 */
export const unwrapDrf = (val) => (Array.isArray(val) ? val[0] : val);
